<div class="change-location-popup">
    <div class="location-card">
        <mat-icon aria-hidden="true" (click)="dismiss()" class="close">clear</mat-icon>
        <p>We don't seem to have your current location. Click on change location to update.</p>
        <button btn-primary size="full" (click)="callToAction()">CHANGE LOCATION</button>
    </div>
</div>